import BaseHeaderComponent from "./BaseHeaderComponent";

const HeaderComponent = ({children, categoryList, setActiveCategory, activeCategory, setActiveVideo}) => {
    return (
        <>
        <header id="home" className="d-section d-header">
            <BaseHeaderComponent categoryList={categoryList} setActiveCategory={setActiveCategory} activeCategory={activeCategory} setActiveVideo={setActiveVideo}/>
            {children}
        </header>
        </>
    );
}

export default HeaderComponent;